import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, Calendar, DollarSign, FileText, Sparkles, Settings } from 'lucide-react';

export function Navigation() {
  const links = [
    { to: '/dashboard', icon: Home, label: 'Home', testId: 'nav-home' },
    { to: '/clients', icon: Users, label: 'Clients', testId: 'nav-clients' },
    { to: '/schedule', icon: Calendar, label: 'Schedule', testId: 'nav-schedule' },
    { to: '/money', icon: DollarSign, label: 'Money', testId: 'nav-money' },
    { to: '/documents', icon: FileText, label: 'Docs', testId: 'nav-documents' },
    { to: '/ai', icon: Sparkles, label: 'AI', testId: 'nav-ai' },
    { to: '/settings', icon: Settings, label: 'Settings', testId: 'nav-settings' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-surface border-t border-border z-40"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-center justify-around max-w-2xl mx-auto">
        {links.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-3 px-4 transition-colors ${isActive ? 'text-primary' : 'text-text-muted hover:text-foreground'}`
            }
            data-testid={testId}
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
